import { Modal, notification, Select } from "antd";
import React, { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import Utils from "../../../../../../utils/Utils";
import WebUtils from "../../../../../../utils/WebUtils";
import { assignInterviewToBatches, interviewAssignedBatchesApi } from "../../../../../../api/org-admin";

function AssignInterviewBatchModal({
  assignGuideBatchFlag,
  setAssignGuideBatchFlag,
  setLoading,
  refreshApis
}) {
  const queryParams = new URLSearchParams(window.location.search);
  const jdId = queryParams.get("jdIdentifier");
  const iDronaId = queryParams.get("iDronaId");

  const userDetail = Utils.getUserDetail();
  const [selectedBatchGuides, setSelectedBatchGuides] = useState([]);
  const [batchGuideData, setBatchGuideData] = useState([]);
  const [batchAssignedGuideData, setBatchAssignedGuideData] = useState([]);

  const getJobGuideData = () => {
    const url = `${interviewAssignedBatchesApi}?organizationId=${userDetail?.organizationId}&iDronaInterviewConfigurationId=${iDronaId}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let data = result?.data?.data;
          setBatchGuideData(data?.organizationBatches);
          setBatchAssignedGuideData(data?.interviewAssignedBatches);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignToBatch = () => {
    let url = `${assignInterviewToBatches}?organizationId=${userDetail?.organizationId}&userIdentifier=${userDetail?.userIdentifier}&iDronaInterviewConfigurationId=${iDronaId}
  `;

    setLoading(true);
    WebUtils.httpOperations(url, selectedBatchGuides, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guides assigned to batch! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          refreshApis()
          setAssignGuideBatchFlag(false);
        } else {
          notification.error({
            message: "Failed",
            description: `${result?.data?.resultStatusInfo.message}`,
            placement: "topRight",
            // showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleSubmit = () => {
    assignToBatch();
  };
  useEffect(() => {
    getJobGuideData();
  }, []);

  const mergedGuideOptions = Array.from(
    new Map([
      ...(batchGuideData || []).map((item) => [
        item.batchIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.batchName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.batchIdentifier})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                Created on{" "}
                {new Date(item.creationDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </div>
          ),

          value: item.batchIdentifier,
          title: item.batchName,
        },
      ]),

      ...(batchAssignedGuideData || []).map((item) => [
        item.batchIdentifier,
        {
          label: (
            <div className="opacity-50">
              <p className="font-medium mb-0 text-gray-900">
                {item.batchName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.batchIdentifier})
                </span>
              </p>
              <p className="text-[.75rem] text-gray-500 mb-0">
                Created on{" "}
                {new Date(item.creationDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>

              <span className="text-[.75rem] text-gray-500 mb-0">
                Already Assigned
              </span>
            </div>
          ),

          value: item.batchIdentifier,
          title: item.batchName,

          disabled: true,
        },
      ]),
    ]).values(),
  );

  return (
    <Modal
      open={assignGuideBatchFlag}
      onCancel={() => setAssignGuideBatchFlag(false)}
      footer={null}
      centered
      width={550}
      title={
        <div className="flex items-center gap-2">
          <span className="p-[9px] rounded-lg border-[2px] border-gray-200 shadow-sm">
            {" "}
            <BookOpen size={22} color="#475467" />
          </span>
          <div>
            <p className="text-[1rem] font-semibold ">Assign mock interview to batch</p>
            <p className="text-[.78rem] font-normal sub-text-color">
              Assign mock interviews to help students prepare for interviews and
              assessments.
            </p>
          </div>
        </div>
      }
    >
      <div className="mt-5">
        <p className="text-[.9rem] font-medium text-[#344054] mb-2">
          Select Batch
        </p>

        <Select
          mode="multiple"
          allowClear
          className="w-full"
          size="large"
          placeholder="Select a batch from list"
          value={selectedBatchGuides}
          onChange={setSelectedBatchGuides}
          options={mergedGuideOptions}
          maxTagCount="responsive"
          optionLabelProp="title"
        />
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setAssignGuideBatchFlag(false)}
        >
          Cancel
        </button>

        <button
          disabled={selectedBatchGuides?.length < 1}
          onClick={handleSubmit}
          className={` ${selectedBatchGuides?.length < 1 ? "btn-disabled" : "btn-orange"} px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Assign Mock Interview
        </button>
      </div>
    </Modal>
  );
}

export default AssignInterviewBatchModal;
